import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  makeStyles,
  Step,
  Stepper,
  StepLabel,
  StepConnector,
  Button,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
// import isEqual from "lodash/isEqual";
// import isEqual from "date-fns/isEqual";
import clsx from "clsx";
// import SponsorDetails from "./SponsorDetails";
import { Country, State, City } from "country-state-city";
// import {
//   ecosystemType,
//   fetchAlpatiaDefaultSettings,
//   fetchRolesAndTypes,
//   fetchUserStatus,
//   fetchViewSponsorDetails,
//   sendBrandOwnerInvitation,
// } from "../../../../containers/actions/ecosystemActions";
import { useDispatch, useSelector } from "react-redux";
import usePrevious from "../../../common/helperFunctions/usePrevious";
import { parsePhoneNumberFromString } from "libphonenumber-js";
// import EcosystemDetails from "./EcosystemDetails";
// import ManufacturingSlotNumberingDetails from "./ManufacturingSlotNumberingDetails";
// import TherapyParameters from "./TherapyParameters";
import { isEqual, set } from "lodash";
// import OptionsAndPermissions from "./OptionsAndPermissions";
// import ReviewEcosystem from "./ReviewEcosystem";
import postalCodes from "postal-codes-js";
// import OpenSuccessDialog from "./OpenSuccessDialog";
import BackDropLoading from "../../../common/helperFunctions/BackDropLoading";
import EcosystemDetails from "./EcosystemDetails";
import NetworkDetails from "./NetworkDetails";
// import SponsorNetworkList from "./SponsorNetworkList";
import OptionsAndPermissions from "./OptionsAndPermissions";
import ReviewEcosystem from "./ReviewEcosystem";
import SponsorDetails from "./SponsorDetails";
import SponsorNetworkList from "./SponsorNetworkList";
import {
  addSponsorNetworkDetails,
  fetchSelectedSponsorDetails,
  saveNetworkConfigurationProgress,
  sendNetworkInvitation,
  updateSponsorNetworkDetails,
} from "../../../../containers/actions/netwrokActions";
import {
  FETCH_SELECTED_SPONSOR_DETAILS,
  FETCH_SELECTED_SPONSOR_DETAILS_LOADING,
  SEND_NETWORK_INVITATION,
} from "../../../../containers/actions/types";
// import {
//   FETCH_ROLES_AND_TYPES,
//   FETCH_VIEW_SPONSOR_DETAILS,
//   FETCH_VIEW_SPONSOR_DETAILS_LOADING,
//   SEND_BRAND_OWNER_INVITATION_NEW,
// } from "../../../../containers/actions/types";
import SponsorNetworkConfigurations from "./Tabs";
import OpenSuccessDialog from "./OpenSuccessDialog";
import axios from "axios";
import { smlUrl } from "../../../../utils/config";

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: "#F5F9FF",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1rem",
    backgroundColor: "#F5F9FF",
  },
  head: {
    textAlign: "center",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: "12px",
    right: "10px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
      color: "#FF0000",
    },
  },
  stepIcon: {
    color: "gray",
    display: "flex",
    height: "22px",
    width: "22px",
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "lightgray",
  },
  active: {
    backgroundColor: "#e36e39",
    color: "white",
  },
  completed: {
    // background: "green",
    color: "green",
  },
  number: {
    fontSize: 12,
    fontWeight: "bold",
  },
  stepLabel: {
    display: "flex",
    alignItems: "center",
  },
  stepButton: {
    padding: 0,
  },
  stepConnector: {
    "& $line": {
      borderColor: "gray",
      borderTopWidth: 2,
      marginTop: -1,
    },
  },
  completedStepConnector: {
    "& $line": {
      borderColor: "green",
    },
  },
  line: {},
  content: {
    marginTop: theme.spacing(2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const steps = [
  "Sponsor Details",
  "Network Details",
  "Sponsor Network Parameters",
  "Options & Permissions",
  "Review & Create Network",
];

const CustomStepIcon = (props) => {
  const classes = useStyles();
  const { active, completed, icon } = props;

  return (
    <div
      className={clsx(classes.stepIcon, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {completed ? (
        <CheckCircleIcon
        // style={{ backgroundColor: "green", borderRadius: "50%" }}
        />
      ) : (
        <Typography className={classes.number}>{icon}</Typography>
      )}
    </div>
  );
};

const CreateNewEcosystemScreen = (props) => {
  const {
    openDialog,
    handleCloseCreateNewEcosystemScreen,
    existingSponsorFlow,
    selectedSponsorDetails,
    // activeStep,
    // setActiveStep,
    // setEcosystemId,
    // ecosystemId,
    // handleRefresh,
    rowData,
    isEditMode,
  } = props;

  const classes = useStyles();
  const dispatch = useDispatch();
  const prevSponsorRef = useRef();
  const prevAdminRef = useRef();
  const [fetchedData, setFetchedData] = useState({});
  const [oldNetworkTypes, setOldNetworkTypes] = useState(null);
  // const initialStep = rowData?.status === "Pending" ? rowData?.activeTab : 0;
  // const [activeStep, setActiveStep] = useState(initialStep);
  // const [activeStep, setActiveStep] = useState(rowData?.activeTab);
  const [completed, setCompleted] = useState({});
  const [networkTypes, setNetworkTypes] = useState([]);
  const [selectedIndices, setSelectedIndices] = useState(null);
 const initialNetworkUrl = rowData?.status === "Pending" ? rowData?.networkURL : "";
  const [networkURL, setNetworkURL] = useState(initialNetworkUrl);
  const [active, setActive] = useState([]);
  const [ecosystemId, setEcosystemId] = useState(null);
        const initialStep = (isEditMode && typeof rowData?.activeTab === "number")
      ? rowData.activeTab
      : 0;
  const [activeStep, setActiveStep] = useState(initialStep);
  const [hasSponsorBeenCreated, setHasSponsorBeenCreated] = useState(false);
const [rowNetwork,setRowNetwork] = useState("");
const [updateNetworkData,setUpdateNetworkData] =useState({});
  const [sponsorDetailsLoading, setSponsorDetailsLoading] = useState(false);


  const [sponsorDetails, setSponsorDetails] = useState({
    sponsorName: "",
    sponsorNameShortcut: "",
    orgCode: "",
    selectedCountry: "",
    states: [],
    selectedState: "",
    cities: [],
    selectedCity: "",
    postCode: "",
    streetAddress1: "",
    streetAddress2: "",
    selectedStatus: "",
  });

  const [adminDetails, setAdminDetails] = useState({
    fullName: "",
    emailAddress: "",
    phone: "",
    countryCode: "in",
  });


  const [optionsAndPermissions, setOptionsAndPermissions] = useState({
    stepAuthenticated: false,
    editPhoneNumber: false,
    azureAdSignIn: false,
  });
  // const fetchViewSponsorLoading=true;
  // const fetchErrors=false;
  const [errors, setErrors] = useState({
    sponsorName: "",
    sponsorNameShortcut: "",
    selectedCountry: "",
    selectedState: "",
    selectedCity: "",
    postCode: "",
    streetAddress1: "",
    streetAddress2: "",
    selectedStatus: "",
    fullName: "",
    emailAddress: "",
    phone: "",
    selectedEcosystemType: "",
    selectedEcosystemId: "",
    ecosystemUrl: "",
    sponsorManufacturingSlotCode: "",
    numberOfSuites: "",
    slotsPerSuites: "",
    suiteIDCode: "",
    daysToSlotExpiry: "",
    selectedCellCountTypes: "",
    selectedOrderUOM: "",
    selectedTherapyUOM: "",
    0: {},
    1: {},
    2: {},
    3: {},
    4: {},
    5: {},
    6: {},
    7: {},
    8: {},
  });

  const [userStatusesData, setUserStatusesData] = useState([]);
  const [ecosystemTypesData, setEcosystemTypesData] = useState([]);
  const [rolesAndTypesData, setRolesAndTypesData] = useState([]);

  const [numberOfSuitesData, setNumberOfSuitesData] = useState([]);
  const [slotsPerSuitesData, setSlotsPerSuitesData] = useState([]);
  const [daysToSlotExpiryData, setDaysToSlotExpiryData] = useState([]);

  const [cellCountTypes, setCellCountTypes] = useState([]);
  const [orderUOM, setOrderUOM] = useState([]);
  const [therapyUOM, setTherapyUOM] = useState([]);
  const [therapyStepDuration, setTherapyStepDuration] = useState([]);
  const [therapyStepDurationAfterChanges, setTherapyStepDurationAfterChanges] =
    useState([]);
  const [addSponsorData, setAddSponsorData] = useState("");
  const [handleReview, setHandleReview] = useState(false);

  const [initialSponsorDetails, setInitialSponsorDetails] = useState(null);
  const [initialAdminDetails, setInitialAdminDetails] = useState(null);

  //   let userStatuses = useSelector((state) =>
  //     state.ecosystems.userStatuses?.statusData
  //       ? state.ecosystems.userStatuses.statusData
  //       : []
  //   );

  //   let prevUserStatuses = usePrevious(userStatuses);

  //   let ecosystemTypes = useSelector((state) =>
  //     state.ecosystems.ecosystemType?.data
  //       ? state.ecosystems.ecosystemType.data
  //       : []
  //   );

  const ecosystemTypes = [
    {
      ecosystemTypeId: 1,
      ecosystemTypeName: "Pharma Contract Manufacturing",
    },
    {
      ecosystemTypeId: 2,
      ecosystemTypeName: "Sponsor Manufacturing Cell Therapy",
    },
    {
      ecosystemTypeId: 3,
      ecosystemTypeName: "Contract Manufacturing Cell Therapy for Sponsor",
    },
    {
      ecosystemTypeId: 4,
      ecosystemTypeName: "In-house Hospital Manufacturing of Cell Therapy",
    },
  ];

  //   let prevEcosystemTypes = usePrevious(ecosystemTypes);

  //   let rolesAndTypes = useSelector((state) =>
  //     state.ecosystems.rolesAndTypes?.data
  //       ? state.ecosystems.rolesAndTypes.data
  //       : []
  //   );
  //   let prevRolesAndTypes = usePrevious(rolesAndTypes);

  //   let alpatiaDefaultSettings = useSelector((state) =>
  //     state.ecosystems?.alpatiaDefaultSettings
  //       ? state.ecosystems.alpatiaDefaultSettings
  //       : []
  //   );
  //   let prevAlpatiaDefaultSettings = usePrevious(alpatiaDefaultSettings);

  //   let fetchViewSponsorLoading = useSelector(
  //     (state) => state.ecosystems.fetchViewSponsorLoading
  //   );

  let fetchViewSponsorData = useSelector(
    (state) => state?.network?.selectedSponsorDetails?.SponsorDetails || []
  );



  //   const addSponsorList = useSelector(
  //   (state) => state?.network?.addSponsorDetails || []
  // );

  const addSponsorList = useSelector((state) => {
    return state?.network?.addSponsorDetails || [];
  });


  const [addDetails, setAddDetails] = useState([]);
  useEffect(() => {
    if (addSponsorList?.data?.ecosystemId) {
      setEcosystemId(addSponsorList?.data?.ecosystemId);
    }
  }, [addSponsorList?.data?.ecosystemId]);
  useEffect(() => {
    if (addSponsorList?.data?.length > 0) {
      setAddSponsorData(addSponsorList);
    }
  }, [addSponsorList]);
  // const selectedSponsorData = useSelector(
  //   (state) => state?.network?.selectedSponsorDetails
  //   );

  // const selectedSponsorData = useSelector((state) => {
  //   return state?.network?.selectedSponsorDetails;
  // });

  const fetchViewSponsorLoading = useSelector(
    (state) => state?.network?.selectedSponsorDetailsLoading
  );

  let fetchErrors = useSelector((state) =>
    state?.network?.selectedSponsorDetails
      ? state?.network?.selectedSponsorDetails
      : {
          status: "false",
          errror: "Something went wrong. Please contact Schrocken Support.",
        }
  );

  useEffect(()=>{
    if(fetchViewSponsorData[0]?.network){
      setRowNetwork(fetchViewSponsorData[0]?.network)
    }
  },[fetchViewSponsorData[0]?.network])



  let prevFetchViewSponsorData = usePrevious(fetchViewSponsorData);
  // useEffect(() => {
  //   if (
  //     JSON.stringify(fetchViewSponsorData) !==
  //       JSON.stringify(prevFetchViewSponsorData) &&
  //     existingSponsorFlow === true
  //   ) {
  //     setSponsorDetails({
  //       ...sponsorDetails,
  //       // sponsorName: fetchViewSponsorData.sponsorDetails?.sponsorName,
  //       // orgCode: fetchViewSponsorData.sponsorDetails?.orgCode,
  //       // selectedCountry: fetchViewSponsorData.sponsorDetails?.country,
  //       // selectedState: fetchViewSponsorData.sponsorDetails?.state,
  //       // selectedCity: fetchViewSponsorData.sponsorDetails?.city,
  //       // postCode: fetchViewSponsorData.sponsorDetails?.postCode,
  //       // streetAddress1: fetchViewSponsorData.sponsorDetails?.address1,
  //       // streetAddress2: fetchViewSponsorData.sponsorDetails?.address2,
  //       sponsorName: fetchViewSponsorData[0]?.sponsorName,
  //       orgCode: fetchViewSponsorData[0]?.organizationCode,
  //       selectedCountry: fetchViewSponsorData[0]?.country,
  //       selectedState: fetchViewSponsorData[0]?.state,
  //       selectedCity: fetchViewSponsorData[0]?.city,
  //       postCode: fetchViewSponsorData[0]?.postCode,
  //       streetAddress1: fetchViewSponsorData[0]?.streetAddress1,
  //       streetAddress2: fetchViewSponsorData[0]?.streetAddress2,
  //       status: fetchViewSponsorData[0]?.status,
  //       fullName: fetchViewSponsorData[0]?.fullName,
  //       phone: fetchViewSponsorData[0]?.phoneNumber,
  //       emailAddress: fetchViewSponsorData[0]?.emailAddress,
  //     });
  //     setFetchedData(fetchViewSponsorData);
  //   }
  //   // setSponsorDetails({
  //   //   ...sponsorDetails,
  //   //   // selectedStatus: defaultStatus ? defaultStatus.statusText : "",
  //   //   selectedStatus: "",
  //   // });
  // }, [
  //   // userStatuses,
  //   // prevUserStatuses,
  //   ecosystemTypes,
  //   // prevEcosystemTypes,
  //   // rolesAndTypes,
  //   // prevRolesAndTypes,
  //   // alpatiaDefaultSettings,
  //   // prevAlpatiaDefaultSettings,
  //   // fetchViewSponsorLoading,
  // ];
  // console.log("fetchViewSponsorData",fetchViewSponsorData)
  // Utility to transform backend sponsor details for SponsorDetails.jsx
  function transformSponsorDetails(backendData) {
    // Robust country matching: try isoCode, then name
    let countryObj = Country.getAllCountries().find(
      (c) => c.isoCode === backendData?.country
    );
    if (!countryObj) {
      countryObj = Country.getAllCountries().find(
        (c) => c.name === backendData?.country
      );
    }
    const countryIso = countryObj ? countryObj.isoCode : "";
    const statesList = countryIso ? State.getStatesOfCountry(countryIso) : [];
    // Robust state matching: try isoCode, then name
    let stateObj = statesList.find((s) => s.isoCode === backendData.state);
    if (!stateObj) {
      stateObj = statesList.find((s) => s.name === backendData.state);
    }
    const stateIso = stateObj ? stateObj.isoCode : "";
    const citiesList = (countryIso && stateIso)
      ? City.getCitiesOfState(countryIso, stateIso)
      : [];
    const cityObj = citiesList.find((c) => c.name === backendData?.city);
    const cityName = cityObj ? cityObj?.name : backendData?.city || "";

    return {
      sponsorName: backendData?.sponsorName,
      sponsorNameShortcut: backendData?.sponsorShortFormName,
      orgCode: backendData?.organizationCode,
      selectedCountry: countryIso,
      states: statesList,
      selectedState: stateIso,
      stateName: backendData?.state,
      cities: citiesList,
      selectedCity: cityName,
      postCode: backendData?.postCode,
      streetAddress1: backendData?.streetAddress1,
      streetAddress2: backendData?.streetAddress2,
      selectedStatus: backendData?.status === "Pending" ? "Active" : backendData?.status,
    };
  }

  useEffect(() => {
    if (
      (isEditMode || existingSponsorFlow) &&
      JSON.stringify(fetchViewSponsorData) !==
        JSON.stringify(prevFetchViewSponsorData) &&
      fetchViewSponsorData?.length > 0
    ) {
      const backendData = fetchViewSponsorData[0];
      setSponsorDetails(transformSponsorDetails(backendData));
      if (isEditMode) {
        setAdminDetails({
          fullName: backendData?.fullName || "",
          phone: backendData?.phoneNumber || "",
          emailAddress: backendData?.emailAddress || "",
          countryCode: "in"
        });
      }
      setFetchedData(fetchViewSponsorData);
      if ((backendData?.ecosystemId && backendData?.organizationId) && isEditMode) {
        setHasSponsorBeenCreated(true);
      }
    }
  }, [fetchViewSponsorData, prevFetchViewSponsorData, isEditMode, existingSponsorFlow]);


  // useEffect(() => {
  //   // dispatch(ecosystemType());
  //   // dispatch(fetchUserStatus());
  //   // dispatch(fetchAlpatiaDefaultSettings());

  //   // if (existingSponsorFlow === true) {
  //   dispatch({
  //     type: FETCH_SELECTED_SPONSOR_DETAILS_LOADING,
  //     payload: true,
  //   });

  //   dispatch(
  //     fetchSelectedSponsorDetails(
  //       // selectedSponsorDetails
  //       {
  //         sponsorId: 2,
  //         ecosystemId: 0,
  //       }
  //     )
  //   );
  //   // }
  // }, []);

  useEffect(() => {
    if (existingSponsorFlow) {

      dispatch({
        type: FETCH_SELECTED_SPONSOR_DETAILS_LOADING,
        payload: true,
      });

      const payload = {
        sponsorId: sponsorDetails?.organizationId || selectedSponsorDetails?.organizationId,
        // ecosystemId: sponsorDetails?.ecosystemId || selectedSponsorDetails?.ecosystemId,
        ecosystemId: 0,
      };
      dispatch(
        fetchSelectedSponsorDetails(payload)
      );
    }
    else if(rowData && !existingSponsorFlow){
      dispatch({
        type: FETCH_SELECTED_SPONSOR_DETAILS_LOADING,
        payload: true,
      });

      dispatch(
        fetchSelectedSponsorDetails({
          sponsorId: rowData?.organizationId,
          ecosystemId: rowData?.ecosystemId,
        })
      );
    }
    else {
    }
  }, [existingSponsorFlow, dispatch, selectedSponsorDetails,rowData?.ecosystemId]);

  const handleDialogClose = () => {
    setHasSponsorBeenCreated(false)
    dispatch({
      type: FETCH_SELECTED_SPONSOR_DETAILS,
      payload: {},
    });
    // dispatch({
    //   type: FETCH_ROLES_AND_TYPES,
    //   payload: [],
    // });
    handleCloseCreateNewEcosystemScreen();
        dispatch(saveNetworkConfigurationProgress({
      activeTab :activeStep ,
	    ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId || 0,

    }))
  };



  const fetchNetworkTypes = async () => {
    try {
      const res = await axios.get(`${smlUrl}/admin/fetchNetworkTypes/${addSponsorList?.data?.ecosystemId || rowData?.ecosystemId}`);
      if (Array.isArray(res.data.NetworkTypes)) {
        const getOldNetworkTypeObj = res.data.NetworkTypes.length > 0 ? res.data.NetworkTypes.find(type => type?.activated === true) : null
        setOldNetworkTypes(getOldNetworkTypeObj); // Store the fetched network types
      } else {
        console.error("Unexpected response format:", res.data);
        setOldNetworkTypes([]); // Fallback to an empty array
      }
    } catch (err) {
      console.error("Error fetching network types:", err);
      setOldNetworkTypes([]); // Fallback to an empty array in case of error
    }
  };


  useEffect(() => {
    if(handleReview){
      fetchNetworkTypes();
    }
  }, [handleReview, addSponsorList?.data?.ecosystemId, rowData?.ecosystemId]);
  
  












  const selectedItem = networkTypes[selectedIndices];

  const prevSelectedStatus = useRef(sponsorDetails?.selectedStatus);


  const [waitingForSponsorCreation, setWaitingForSponsorCreation] = useState(false);

  const handleNext = ({ sponsorDetails, adminDetails } = {}) => {
    setCompleted((prevCompleted) => ({
      ...prevCompleted,
      [activeStep]: true,
    }));    if (activeStep === 0) {
      setSponsorDetailsLoading(true); // Set loading state when saving sponsor details
      if (isEditMode) {
        // Convert country and state codes to names for update
        let countryObj = Country.getAllCountries().find(
            (c) => c.isoCode === sponsorDetails.selectedCountry
        ) || Country.getAllCountries().find(
            (c) => c.name === sponsorDetails.selectedCountry
          );
        const countryName = countryObj ? countryObj.name : sponsorDetails.selectedCountry;
        const statesList = State.getStatesOfCountry(countryObj ? countryObj.isoCode : "");
        let stateObj = statesList.find((s) => s.isoCode === sponsorDetails.selectedState);
        if (!stateObj) {
          stateObj = statesList.find((s) => s.name === sponsorDetails.selectedState);
        }
        const stateName = stateObj ? stateObj.name : sponsorDetails.selectedState;
        const data = {
          sponsorId: rowDataState.organizationId,
          ecosystemId: rowDataState.ecosystemId,
          streetAddress1: sponsorDetails.streetAddress1,
          streetAddress2: sponsorDetails.streetAddress2,
          city: sponsorDetails.selectedCity,
          state: stateName,
          postCode: sponsorDetails.postCode,
          country: countryName,
          orgStatus: sponsorDetails.selectedStatus,
          fullName: adminDetails.fullName,
          phoneNumber: adminDetails.phone,
          emailAddress: adminDetails.emailAddress
        };
        dispatch(updateSponsorNetworkDetails(data));
      } else if (!hasSponsorBeenCreated) {
        // Convert country and state codes to names for add
        let countryObj = Country.getAllCountries().find(
            (c) => c.isoCode === sponsorDetails.selectedCountry
        ) || Country.getAllCountries().find(
            (c) => c.name === sponsorDetails.selectedCountry
          );
        const countryName = countryObj ? countryObj.name : sponsorDetails.selectedCountry;
        const statesList = State.getStatesOfCountry(countryObj ? countryObj.isoCode : "");
        let stateObj = statesList.find((s) => s.isoCode === sponsorDetails.selectedState);
        if (!stateObj) {
          stateObj = statesList.find((s) => s.name === sponsorDetails.selectedState);
        }
        const stateName = stateObj ? stateObj.name : sponsorDetails.selectedState;
        const payload = {
          sponsorDetails: {
            sponsorName: sponsorDetails.sponsorName,
            sponsorShortName: sponsorDetails.sponsorNameShortcut,
            streetAddress1: sponsorDetails.streetAddress1,
            streetAddress2: sponsorDetails.streetAddress2,
            city: sponsorDetails.selectedCity,
            state: stateName,
            postCode: sponsorDetails.postCode,
            country: countryName,
            status: sponsorDetails.selectedStatus,
          },
          adminDetails: {
            collaboratorRoleId: 1,
            collaboratorRoleName: "Admin",
            collaboratorTypeId: 1,
            fullName: adminDetails.fullName,
            email: adminDetails.emailAddress,
            phone: adminDetails.phone,
          },
        };
        // return;
        dispatch(addSponsorNetworkDetails(payload));
        setHasSponsorBeenCreated(true);
        setWaitingForSponsorCreation(true);
        return;
      } else {
        // Convert country and state codes to names for update after add
        let countryObj = Country.getAllCountries().find(
            (c) => c.isoCode === sponsorDetails.selectedCountry
        ) || Country.getAllCountries().find(
            (c) => c.name === sponsorDetails.selectedCountry
          );
        const countryName = countryObj ? countryObj.name : sponsorDetails.selectedCountry;
        const statesList = State.getStatesOfCountry(countryObj ? countryObj.isoCode : "");
        let stateObj = statesList.find((s) => s.isoCode === sponsorDetails.selectedState);
        if (!stateObj) {
          stateObj = statesList.find((s) => s.name === sponsorDetails.selectedState);
        }
        const stateName = stateObj ? stateObj.name : sponsorDetails.selectedState;
        const data = {
          sponsorId: rowDataState.organizationId,
          ecosystemId: rowDataState.ecosystemId,
          streetAddress1: sponsorDetails.streetAddress1,
          streetAddress2: sponsorDetails.streetAddress2,
          city: sponsorDetails.selectedCity,
          state: stateName,
          postCode: sponsorDetails.postCode,
          country: countryName,
          orgStatus: sponsorDetails.selectedStatus,
          fullName: adminDetails.fullName,
          phoneNumber: adminDetails.phone,
          emailAddress: adminDetails.emailAddress
        };
        dispatch(updateSponsorNetworkDetails(data));
      }
    }
    // For other steps, move as usual
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    prevSponsorRef.current = sponsorDetails;
    prevAdminRef.current = adminDetails;
  };


  useEffect(() => {
    if (activeStep > 0) {
      const initialCompleted = {};
      for (let i = 0; i < activeStep; i++) {
        initialCompleted[i] = true;
      }
      setCompleted(initialCompleted);
    }
  }, []);

  // Watch for sponsor creation success
  useEffect(() => {
    if (
      waitingForSponsorCreation &&
      addSponsorList?.status === true &&
      addSponsorList?.data?.ecosystemId
    ) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setWaitingForSponsorCreation(false);
    }
  }, [waitingForSponsorCreation, addSponsorList]);
  const handleBack = () => {
    setCompleted((prevCompleted) => {
      const newCompleted = { ...prevCompleted };
      delete newCompleted[activeStep - 1];
      return newCompleted;
    });

    // If we're moving to step 0 (Sponsor Details), ensure loading state is reset
    if (activeStep === 1) {
      setSponsorDetailsLoading(false);
    }

    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  // Sponsor Name handling functions
  const validateSponsorName = (value) => {
    return value.trim() === "" ? "Sponsor Name is required" : "";
  };

  const handleSponsorNameChange = (event) => {
    const value = event.target.value;
    // Update state immediately
    setSponsorDetails(prevState => ({
      ...prevState,
      sponsorName: value
    }));

    // Validate after state update
    const errorMessage = validateSponsorName(value);
    setErrors(prevErrors => ({
      ...prevErrors,
      sponsorName: errorMessage
    }));
  };

  const handleSponsorNameBlur = (event) => {
    // Trim leading and trailing spaces when user is done typing
    const trimmed = event.target.value.trim();
    if (trimmed !== event.target.value) {
      setSponsorDetails({ ...sponsorDetails, sponsorName: trimmed });
    }
    const errorMessage = validateSponsorName(trimmed);
    setErrors((prevErrors) => ({ ...prevErrors, sponsorName: errorMessage }));
  };

  const validateSponsorShortcutName = (value) => {
    return value.trim() === "" ? "Sponsor Name is required" : "";
  };
  const handleSponsorShortcutNameChange = (event) => {
    const value = event.target.value;
    setSponsorDetails({ ...sponsorDetails, sponsorNameShortcut: value });
    const errorMessage = validateSponsorShortcutName(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      sponsorNameShortcut: errorMessage,
    }));
  };

  const handleSponsorShortcutNameBlur = (event) => {
    // Trim leading and trailing spaces when user is done typing
    const trimmed = event.target.value.trim();
    if (trimmed !== event.target.value) {
      setSponsorDetails({ ...sponsorDetails, sponsorNameShortcut: trimmed });
    }
    const errorMessage = validateSponsorShortcutName(trimmed);
    setErrors((prevErrors) => ({
      ...prevErrors,
      sponsorNameShortcut: errorMessage,
    }));
  };

  // Country Name handling functions
  const validateCountry = (value) => {
    return value === "" ? "Country is required" : "";
  };
  // const handleCountryChange = (event) => {

  //   const value = event.target.value;
  //   setSponsorDetails({ ...sponsorDetails, selectedCountry: value });
  //   const errorMessage = validateCountry(value);
  //   setErrors((prevErrors) => ({
  //     ...prevErrors,
  //     selectedCountry: errorMessage,
  //     // selectedState: true,
  //     // selectedCity: true,
  //   }));
  // };

  const handleCountryChange = (event) => {
    const value = event.target.value;
    // Clear state, city and post code when country changes
    setSponsorDetails({
      ...sponsorDetails,
      selectedCountry: value,
      selectedState: "",
      selectedCity: "",
      postCode: "" 
    });
    const errorMessage = validateCountry(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      selectedCountry: errorMessage,
      selectedState: "State is required",
      selectedCity: "City is required",
      postCode: "Post Code is required"
    }));
  };

  // State Name handling functions
  useEffect(() => {
    if (sponsorDetails.selectedCountry && existingSponsorFlow === false) {
      const states = State.getStatesOfCountry(sponsorDetails.selectedCountry);
      setSponsorDetails((prevDetails) => ({
        ...prevDetails,
        states: states,
        selectedState: prevDetails.selectedState || "",
        postCode: prevDetails.postCode || "",
        cities: prevDetails.cities || [],
      }));
    }
  }, [sponsorDetails.selectedCountry]);

  const validateState = (value) => {
    return value === "" ? "State is required" : "";
  };

  const handleStateChange = (event) => {
    const value = event.target.value;
    // Clear city and post code when state changes
    setSponsorDetails({
      ...sponsorDetails,
      selectedState: value,
      selectedCity: "",
      postCode: ""
    });
    const errorMessage = validateState(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      selectedState: errorMessage,
      selectedCity: "City is required",
      postCode: "Post Code is required"
    }));
  };

  // City Name handling functions

  useEffect(() => {
    if (sponsorDetails.selectedState && existingSponsorFlow === false) {
      const cities = City.getCitiesOfState(
        sponsorDetails.selectedCountry,
        sponsorDetails.selectedState
      );
      setSponsorDetails((prevDetails) => ({
        ...prevDetails,
        cities: cities,
        selectedCity: prevDetails.selectedCity || "",
        postCode: prevDetails.postCode || "",
      }));
    }
  }, [sponsorDetails.selectedState]);

  const validateCity = (value) => {
    return value === "" ? "City is required" : "";
  };

  const handleCityChange = (event) => {
    const value = event.target.value;
    setSponsorDetails({ ...sponsorDetails, selectedCity: value, postCode: "" });
    const errorMessage = validateCity(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      selectedCity: errorMessage,
      postCode: "Post Code is required"
    }));
  };

  // Post Code handling functions

  const validatePostCode = (value, country) => {
    if (value.trim() === "") {
      return "Post Code is required";
    }
    if (country) {
      const isValid = postalCodes.validate(country, value);
      if (isValid === true) {
        return "";
      } else {
        return "Invalid postal code";
      }
    }
    return "";
  };

  const handlePostCodeChange = (event) => {
    const value = event.target.value;
    const country = sponsorDetails.selectedCountry;

    setSponsorDetails({ ...sponsorDetails, postCode: value });

    const errorMessage = validatePostCode(value, country);
    setErrors((prevErrors) => ({ ...prevErrors, postCode: errorMessage }));
  };

  const handlePostCodeBlur = (event) => {
    // Trim leading and trailing spaces when user is done typing
    const trimmed = event.target.value.trim();
    const country = sponsorDetails.selectedCountry;

    if (trimmed !== event.target.value) {
      setSponsorDetails({ ...sponsorDetails, postCode: trimmed });
    }

    const errorMessage = validatePostCode(trimmed, country);
    setErrors((prevErrors) => ({ ...prevErrors, postCode: errorMessage }));
  };

  const validateStreetAddress1 = (value) => {
    return value.trim() === "" ? "Street Address 1 is required" : "";
  };

  const handleStreetAddress1Change = (event) => {
    const value = event.target.value;
    setSponsorDetails({ ...sponsorDetails, streetAddress1: value });
    const errorMessage = validateStreetAddress1(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      streetAddress1: errorMessage,
    }));
  };

  const handleStreetAddress1Blur = (event) => {
    // Trim leading and trailing spaces when user is done typing
    const trimmed = event.target.value.trim();
    if (trimmed !== event.target.value) {
      setSponsorDetails({ ...sponsorDetails, streetAddress1: trimmed });
    }
    const errorMessage = validateStreetAddress1(trimmed);
    setErrors((prevErrors) => ({
      ...prevErrors,
      streetAddress1: errorMessage,
    }));
  };

  const validateStreetAddress2 = (value) => {
    return value.trim() === "" ? "Street Address 2 is required" : "";
  };
  const handleStreetAddress2Change = (event) => {
    const value = event.target.value;
    setSponsorDetails({ ...sponsorDetails, streetAddress2: value });
    const errorMessage = validateStreetAddress2(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      streetAddress2: errorMessage,
    }));
  };

  const handleStreetAddress2Blur = (event) => {
    // Trim leading and trailing spaces when user is done typing
    const trimmed = event.target.value.trim();
    if (trimmed !== event.target.value) {
      setSponsorDetails({ ...sponsorDetails, streetAddress2: trimmed });
    }
    const errorMessage = validateStreetAddress2(trimmed);
    setErrors((prevErrors) => ({
      ...prevErrors,
      streetAddress2: errorMessage,
    }));
  };

  const validateStatus = (value) => {
    return value === "" ? "Status is required" : "";
  };
  const handleStatusChange = (event) => {
    const value = event.target.value;
    setSponsorDetails({ ...sponsorDetails, selectedStatus: value });
    const errorMessage = validateStatus(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      selectedStatus: errorMessage,
    }));
  };

  const validateFullName = (value) => {
    return value.trim() === "" ? "Full Name is required" : "";
  };

  const handleFullNameChange = (event) => {
    const value = event.target.value;
    setAdminDetails({ ...adminDetails, fullName: value });
    const errorMessage = validateFullName(value);
    setErrors((prevErrors) => ({ ...prevErrors, fullName: errorMessage }));
  };

  const handleFullNameBlur = (event) => {
    // Trim leading and trailing spaces when user is done typing
    const trimmed = event.target.value.trim();
    if (trimmed !== event.target.value) {
      setAdminDetails({ ...adminDetails, fullName: trimmed });
    }
    const errorMessage = validateFullName(trimmed);
    setErrors((prevErrors) => ({ ...prevErrors, fullName: errorMessage }));
  };

  const validateEmailAddress = (value) => {
    if (value.trim() === "") {
      return "Email Address is required";
    } else if (!/\S+@\S+\.\S+/.test(value)) {
      return "Invalid email address";
    }
    return "";
  };
  const handleEmailAddressChange = (event) => {
    const value = event.target.value;
    setAdminDetails({ ...adminDetails, emailAddress: value });
    const errorMessage = validateEmailAddress(value);
    setErrors((prevErrors) => ({ ...prevErrors, emailAddress: errorMessage }));
  };

  const handleEmailAddressBlur = (event) => {
    // Trim leading and trailing spaces when user is done typing
    const trimmed = event.target.value.trim();
    if (trimmed !== event.target.value) {
      setAdminDetails({ ...adminDetails, emailAddress: trimmed });
    }
    const errorMessage = validateEmailAddress(trimmed);
    setErrors((prevErrors) => ({ ...prevErrors, emailAddress: errorMessage }));
  };

  // Handle phone number change
  const validatePhone = (phone) => {
    if (!phone || phone.trim() === "") {
      return "Enter Phone Number";
    }

    // Basic validation for international phone numbers
    // Must be at least 8 digits (excluding country code and special characters)
    const digitsOnly = phone.replace(/\D/g, '');
    if (digitsOnly.length < 8) {
      return "Phone number must have at least 8 digits";
    }

    return "";
  };

  const handlePhoneChange = (phone, country) => {
    // Update the phone number and country code in state
    setAdminDetails((prevDetails) => ({
      ...prevDetails,
      phone: phone,
      countryCode: country.countryCode
    }));

    // Validate the phone number
    const errorMessage = validatePhone(phone);
    setErrors((prevErrors) => ({ ...prevErrors, phone: errorMessage }));
  };

  const handleChangeOptionsAndPermissions = (event) => {
    setOptionsAndPermissions({
      ...optionsAndPermissions,
      [event.target.name]: event.target.checked,
    });
  };

  const handleTherapyStepDurationsChange = (index, field, value) => {
    const updatedData = [...therapyStepDurationAfterChanges];
    const newValue = parseInt(value, 10);

    updatedData[index][field] = isNaN(newValue) ? "" : newValue;

    if (field === "minimum_value") {
      if (newValue > updatedData[index].default_value) {
        updatedData[index].default_value = "";
      }
      if (newValue >= updatedData[index].maximum_value) {
        updatedData[index].maximum_value = "";
      }
    } else if (field === "maximum_value") {
      if (newValue < updatedData[index].default_value) {
        updatedData[index].default_value = "";
      }
      if (newValue <= updatedData[index].minimum_value) {
        updatedData[index].minimum_value = "";
      }
    } else if (field === "default_value") {
      if (newValue < updatedData[index].minimum_value) {
        updatedData[index].minimum_value = "";
      }
      if (newValue > updatedData[index].maximum_value) {
        updatedData[index].maximum_value = "";
      }
    }

    // Set errors if any field is empty
    const newErrors = { ...errors };
    if (updatedData[index][field] === "") {
      newErrors[index] = {
        ...newErrors[index],
        [field]: "This field is required",
      };
    } else {
      if (newErrors[index]) {
        delete newErrors[index][field];
      }
    }
    setErrors(newErrors);
    setTherapyStepDurationAfterChanges(updatedData);
  };

  const [loading, setLoading] = useState(false);

  const handleSendInvitation = () => {
    setUpdateError(false);
    setHandleReview(true);
    setLoading(true);

  };

  useEffect(() => {
    if(handleReview){
      dispatch({
        type: SEND_NETWORK_INVITATION,
        payload: {},
      });
      const data = {
        ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
        sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        organizationName: sponsorDetails?.sponsorName,
        collaboratorTypeName: "Sponsor",
        collaboratorTypeId: 1,
        email: adminDetails?.emailAddress,
        fullName: adminDetails?.fullName,
        phoneNumber: adminDetails?.phone,
        countryCode: sponsorDetails?.selectedCountry,
        ecosystemTypeName: oldNetworkTypes?.networkType,
        ecosystemTypeId: oldNetworkTypes?.ecosystem_type_id,
        organizationCode: sponsorDetails?.orgCode || addSponsorList?.data?.organizationCode,
      };

      if (oldNetworkTypes) {
        dispatch(sendNetworkInvitation(data));
      }
    }
  },[handleReview, oldNetworkTypes])

  

  const didMountRef = useRef(false);

  const [updateError, setUpdateError] = useState(false);
  const [updatedData, setUpdatedData] = useState({});
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const sendInvitation = useSelector(
    (state) => state.network?.sendInvite || {}
  );
  const prevSendInvitation = usePrevious(sendInvitation);

  useEffect(() => {
    if (didMountRef.current) {
      if (
        JSON.stringify(sendInvitation) !== JSON.stringify(prevSendInvitation)
      ) {
        setLoading(false);
        if (sendInvitation.status === true) {
          setUpdateError(false);
          setUpdatedData(sendInvitation);
          setOpenSuccessDialog(true);
        } else if (sendInvitation.status === false) {
          setUpdateError(true);
          setUpdatedData(sendInvitation);
          setOpenSuccessDialog(false);
          scrollToTop();
        }
      }
    } else {
      didMountRef.current = true;
    }
  }, [sendInvitation, prevSendInvitation]);

  const handleCloseSuccessDialog = () => {
    setOpenSuccessDialog(false);
    handleCloseCreateNewEcosystemScreen();
  };
  const errRef = useRef();
  const scrollToTop = () => {
    if (errRef.current) {
      errRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  };


  const [rowDataState, setRowDataState] = useState(rowData || {});

  useEffect(() => {
    if (addSponsorList?.data?.organizationId && addSponsorList?.data?.ecosystemId) {
      setRowDataState((prev) => ({
        ...prev,
        organizationId: addSponsorList.data.organizationId,
        ecosystemId: addSponsorList.data.ecosystemId,
      }));
    }
  }, [addSponsorList]);

  useEffect(() => {
    if (!isEditMode) {
      setAdminDetails({
        fullName: "",
        emailAddress: "",
        phone: "",
        countryCode: "in",
      });
    }
  }, [isEditMode]);

  // Reset loading states on component mount
  useEffect(() => {
    setSponsorDetailsLoading(false);
  }, []);

  return (
    <Dialog open={openDialog} fullScreen>
      <BackDropLoading />
      <DialogTitle style={{ padding: "0px" }}>
        <Grid item xs={12} className={classes.header}>
          <Grid item xs={12} className={classes.titleGrid}>
            <Grid item xs={12} className={classes.head}>
              <Typography variant="h6" style={{ fontSize: "1.875rem" }}>
                Create New Network
              </Typography>
              <Typography>
                Invite Sponsor Admin To Access The Network
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={2} sm={2} md={2}>
            <Typography
              variant="body2"
              className={classes.closeBtn}
              onClick={handleDialogClose}
            >
              Cancel{" "}
              <CloseIcon style={{ fontSize: "35px", color: "#FF0000" }} />
            </Typography>
          </Grid>
        </Grid>
      </DialogTitle>
      {fetchViewSponsorLoading === true && existingSponsorFlow === true ? (
        <DialogContent>
          <div
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress thickness="7" />
          </div>
        </DialogContent>
      ) : existingSponsorFlow === true && fetchErrors.status === false ? (
        <Grid
          style={{
            paddingLeft: "150px",
            paddingRight: "150px",
            paddingTop: "30px",
          }}
        >
          <Typography
            style={{
              border: "2px solid rgb(255,0,0)",
              backgroundColor: "rgb(255,240,240)",
              Opacity: 1,
              textAlign: "center",
              padding: "0.8rem",
              fontSize: "0.875rem",
            }}
          >
            {fetchErrors.error}
          </Typography>
        </Grid>
      ) : (
        <DialogContent>
          <Stepper
            alternativeLabel
            nonLinear
            activeStep={activeStep}
            connector={
              <StepConnector
                classes={{
                  active: classes.stepConnector,
                  completed: classes.completedStepConnector,
                  line: classes.line,
                }}
              />
            }
          >
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel
                  StepIconComponent={(props) => (
                    <CustomStepIcon
                      {...props}
                      completed={completed[index]}
                      icon={index + 1}
                    />
                  )}
                >
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>

          {updateError === true && (
            <Grid
              ref={(el) => {
                errRef.current = el;
              }}
              style={{
                paddingTop: "8px",
                width: "93%",
                paddingBottom: "16px",
              }}
            >
              <Typography
                variant="h6"
                style={{
                  border: "1px solid #FF0000",
                  backgroundColor: "#FFF0F0",
                  opacity: "1",
                  textAlign: "center",
                  padding: "0.8rem",
                  fontSize: "0.875rem",
                }}
              >
                {updatedData?.errorDescription
                  ? updatedData.errorDescription
                  : updatedData.errorMessage}
              </Typography>
            </Grid>
          )}

          <Grid
            style={{
              paddingLeft: "150px",
              paddingTop: "32px",
            }}
          >
            {activeStep === 0 && (
              <SponsorDetails
                sponsorDetails={sponsorDetails}
                Country={Country}
                errors={errors}
                rowData={rowDataState}
                isEditMode={isEditMode}
                handleSponsorNameChange={handleSponsorNameChange}
                handleSponsorNameBlur={handleSponsorNameBlur}
                handleSponsorShortcutNameChange={
                  handleSponsorShortcutNameChange
                }
                handleSponsorShortcutNameBlur={handleSponsorShortcutNameBlur}
                handleCountryChange={handleCountryChange}
                handleStateChange={handleStateChange}
                handleCityChange={handleCityChange}
                handlePostCodeChange={handlePostCodeChange}
                handlePostCodeBlur={handlePostCodeBlur}
                handleStreetAddress1Change={handleStreetAddress1Change}
                handleStreetAddress1Blur={handleStreetAddress1Blur}
                handleStreetAddress2Change={handleStreetAddress2Change}
                handleStreetAddress2Blur={handleStreetAddress2Blur}
                userStatusesData={userStatusesData}
                handleStatusChange={handleStatusChange}
                adminDetails={adminDetails}
                handleFullNameChange={handleFullNameChange}
                handleFullNameBlur={handleFullNameBlur}
                handleEmailAddressChange={handleEmailAddressChange}
                handleEmailAddressBlur={handleEmailAddressBlur}
                handlePhoneChange={handlePhoneChange}
                handleNext={handleNext}
                existingSponsorFlow={existingSponsorFlow}
                sponsorDetailsLoading={sponsorDetailsLoading}
                setSponsorDetailsLoading={setSponsorDetailsLoading}
              />
            )}

            {activeStep === 1 && (
              <NetworkDetails
                addSponsorList={addSponsorList}
                rowData={rowDataState}
                rowNetwork={rowNetwork}
                updateNetworkData={updateNetworkData}
                addDetails={addDetails}
                handleBack={handleBack}
                handleNext={handleNext}
                setUpdateNetworkData={setUpdateNetworkData}
                networkTypes={networkTypes}
                setNetworkTypes={setNetworkTypes}
                selectedIndices={selectedIndices}
                setSelectedIndices={setSelectedIndices}
                networkURL={networkURL}
                setNetworkURL={setNetworkURL}
                active={active}
                setActive={setActive}
                existingSponsorFlow={existingSponsorFlow}
              />
            )}

            {activeStep === 2 && (
              <SponsorNetworkConfigurations
              
                addSponsorList={addSponsorList}
                rowNetwork={rowNetwork}
                updateNetworkData={updateNetworkData}
                rowData={rowDataState}
                sponsorHandleNext={handleNext}
                sponsorHandleBack={handleBack}
              />
            )}

            {activeStep === 3 && (
              <OptionsAndPermissions
                rowData={rowDataState}
                rowNetwork={rowNetwork}
                updateNetworkData={updateNetworkData}
                optionsAndPermissions={optionsAndPermissions}
                handleChangeOptionsAndPermissions={
                  handleChangeOptionsAndPermissions
                }
                handleNext={handleNext}
                handleBack={handleBack}
              />
            )}

            {activeStep === 4 && (
              <ReviewEcosystem
                rowData={rowDataState}
                rowNetwork={rowNetwork}
                updateNetworkData={updateNetworkData}
                sponsorDetails={sponsorDetails}
                adminDetails={adminDetails}
                networkTypes={networkTypes}
                selectedIndices={selectedIndices}
                networkURL={networkURL}
                addSponsorList={addSponsorList}
                handleBack={handleBack}
                handleSendInvitation={handleSendInvitation}
                existingSponsorFlow={existingSponsorFlow}
                oldNetworkTypes={oldNetworkTypes}
                isLoading={loading}
              />
            )}
          </Grid>
          {openSuccessDialog && (
            <OpenSuccessDialog
              openDialog={openSuccessDialog}
              updatedData={updatedData}
              handleCloseSuccessDialog={handleCloseSuccessDialog}
            />
          )}      </DialogContent>
      )}
    </Dialog>
  );
};

export default CreateNewEcosystemScreen;
